import { useEffect } from "react";

import { connect } from 'react-redux';

import { Actions as COMPANYACTIONS } from '../../store/actions/companyActions';
import { Actions as PAYMENTACTIONS } from '../../store/actions/paymentActions';

import { TrashIcon } from "@heroicons/react/20/solid";
import { CreditCardIcon, } from "@/icons/outline";
import { Elements } from '@stripe/react-stripe-js';
import { components } from 'react-select';
import { stripePromise } from "../../store/actions/apiURL";
import CheckoutForm from './CheckoutForm';

const { Option } = components;


// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.

const PaymentMethods = ({
	advisorCharge,
	paymentOptions,
	planOptions,
	// businessDetails,	
	stripePaymentMethods,
	getStripePaymentMethods,
	createStripeCharge,
	currency,
	addNewCard,
	setAddNewCard,
	payNow,
	paymentIntent,
	processStripeCharge,
	processingStripeCharge,
	getBundles,
	selectedMethod,
	bundles,
	stats,
	updateSetting,
	showStripeDeleteModal,
	creditsToPay
}) => {

	useEffect(() => {
		getBundles()
	}, []);

	// const stripe = useStripe();

	const on3DSComplete = async (intent, secret) => {
		// Check the PaymentIntent

		// should normally not wait as it would have already resolved
		const stripe = await stripePromise;

		stripe.retrievePaymentIntent(secret)
			.then(function (result) {
				console.log('result.paymentIntent', result.paymentIntent)

				if (result.error) {
					// PaymentIntent client secret was invalid
				} else {
					if (result.paymentIntent.status === 'succeeded') {
						// Show your customer that the payment has succeeded

						// send redux action to save intent as succeeded
						processStripeCharge(intent)

					} else if (result.paymentIntent.status === 'requires_payment_method') {
						// Authentication failed, prompt the customer to enter another payment method
					}
				}
			});
	}

	const setSelectedMethod = (id) => updateSetting('defaultCard', id)

	// const [sidebarOpen, setSidebarOpen] = useState(false)
	useEffect(() => {
		if (!stats) return
		getStripePaymentMethods(advisorCharge)

		window.addEventListener('message', function (ev) {
			if (ev.data["3DS"] == true) {
				on3DSComplete(ev.data.intent, ev.data.secret);
			}
		}, false);

	}, [stats]);

	useEffect(() => {
		if (stripePaymentMethods && stripePaymentMethods.length == 0 && !addNewCard) {
			setAddNewCard(true)
		}
	}, [stripePaymentMethods?.length, addNewCard]);

	if (paymentIntent && paymentIntent.status == "requires_action") {
		return (
			<div
				style={{
					background: "white",
					margin: "auto",
					minWidth: 600,
					maxWidth: 600,
					width: 600,
					padding: "0",
					top: "50%",
					left: "50%",
					width: "100%",
					transform: "translateY(-50%) TranslateX(-50%)",
					position: "absolute",
				}}>
				<iframe
					src={paymentIntent.next_action.redirect_to_url.url}
					width={600}
					height={400}
				/>
			</div>
		)
	}

	if (!paymentOptions) return (
		<Elements stripe={stripePromise}>
			<CheckoutForm advisorCharge={advisorCharge}/>
		</Elements>
	)

	return (
		<div style={{ marginRight: '8rem', marginLeft: '8rem', marginBottom: '2rem' }}>
			{/* <div className="form-inner-box" style={{ marginLeft: '4.5rem', padding: '2rem', marginBottom: '2rem', width: '90%' }}>
				<div className="pull-left">
					<div className="chip" style={{ background: '#ffdecd', marginRight: '2rem' }}>
						<CreditCardIcon style={{ height: '2.5rem', color: '#ea611c' }} />
					</div>
				</div>
				<div className="pull-left">
					<span className="sup-text">
						{selectedMethod?.brand?.split(' ')?.map(c => c[0].toUpperCase() + c.substring(1).toLowerCase()).join(' ')} ending in {selectedMethod?.last4}
					</span>
					<p className="sub-text">Expires on {selectedMethod?.expiry}</p>
				</div>
				<div className="pull-right">
					<div
						className="btn btn-primary"
						style={{ marginRight: 10 }}
						onClick={() => { setEditCard(!editCard) }}
					>
						Choose another card
					</div>
				</div>
				<div className="clearfix" />
			</div> */}
			{/* {editCard && */}
			{paymentOptions?.map(paymentOption => {
				return (
					<div className="col-sm-12 pl-0 pr-0 form-inner-box">
						<div style={{ display: "flex", minHeight: '7rem' }} className="radio-container">
							<label htmlFor={`paymentOption${paymentOption.value}`} className="radio-block" style={{ padding: 0, margin: 10, width: "95%" }}>
								<div className="pull-left">
									<div className="chip" style={{ background: '#ffdecd', marginRight: '2rem' }}>
										<CreditCardIcon style={{ height: '2.5rem', color: '#ea611c' }} />
									</div>
								</div>
								<div className="pull-left">
									<span className="sup-text">
										{paymentOption?.brand?.split(' ')?.map(c => c[0].toUpperCase() + c.substring(1).toLowerCase()).join(' ')} ending in {paymentOption?.last4}
									</span>
									<p className="sub-text">Expires on {paymentOption?.expiry}</p>
								</div>
								{ stripePaymentMethods.length > 1 &&
									<button className="btn btn-danger pull-right" 
										style={{marginRight: 10, marginTop: 10}}
										onClick={() => {
											showStripeDeleteModal(paymentOption?.value)
										}}>
												<TrashIcon style={{ height: "1em", float: "left"}}/>
									</button>
								}
							</label>
							<input
								style={{ width: "5%", marginRight: '2rem', maxWidth: '25px' }}
								id={`paymentOption${paymentOption.value}`}
								type="radio"
								name='paymentOptionsOptions'
								className="pull-right radio-primary"
								checked={selectedMethod?.value == paymentOption?.value}
								onClick={() => {
									setSelectedMethod(paymentOption?.value)
								}}
								value={paymentOption.value}
							/>
						</div>
					</div>
				)
			})}
			<div className="clearfix" />
			{addNewCard ?
				<Elements stripe={stripePromise}>
					<CheckoutForm advisorCharge={advisorCharge}/>
				</Elements>
				:
				<div className="col-xs-12 pr-0">
					<div
						className="btn-primary btn pull-left"
						onClick={() => setAddNewCard(true)}
					>Add Another Card</div>

					{ creditsToPay &&
					<div
						className="btn-primary btn pull-right"
						onClick={() => payNow(advisorCharge)}
					>Pay {currency}{creditsToPay} Pending Balance</div>}
				</div>
			}
			<div className="clearfix" />
		</div>
	)
}

const mapStateToProps = (state) => {
	const paymentOptions = state.payment?.stripe?.paymentMethods?.map(item => ({
		value: item.id,
		label: `•••• •••• •••• ${item.card.last4} - ${item.card.exp_month}/${item.card.exp_year}`,
		brand: item.card.brand,
		last4: item.card.last4,
		expiry: `${item.card.exp_month}/${item.card.exp_year}`,
		email: item.billing_details.email,
		phone: item.billing_details.phone
	}))
	const selectedMethod = paymentOptions?.find(item => item.value == state.company?.settings?.defaultCard)

	const { stats, stripe } = state.payment || {}


	return {
		paymentOptions,
		selectedMethod,
		// businessDetails: state?.payment?.stats?.businessDetails,
		addNewCard: stripe?.addNewCard,
		stripePaymentMethods: stripe?.paymentMethods,
		processingStripeCharge: stripe?.processingCharge,
		paymentIntent: stripe?.paymentIntent,
		currency: state.company?.settings?.currency,
		stats: !!stats,
		creditsToPay: stats?.creditBalance < 0 ? -stats?.creditBalance: false,
	}
}


const mapDispatchToProps = dispatch => ({
	getBundles: () => dispatch(PAYMENTACTIONS.getBundles()),
	processStripeCharge: (intentID) => dispatch(PAYMENTACTIONS.processStripeCharge(intentID)),
	createStripeCharge: (paymentMethodID) => dispatch(PAYMENTACTIONS.createStripeCharge(paymentMethodID)),
	getStripePaymentMethods: (advisorCharge) => dispatch(PAYMENTACTIONS.getStripePaymentMethods(null,advisorCharge)),
	clearBundle: () => dispatch(PAYMENTACTIONS.selectBundle(null)),
	setAddNewCard: (status) => dispatch(PAYMENTACTIONS.addNewCard(status)),
	payNow: (advisorCharge) => dispatch(PAYMENTACTIONS.payNow(null,advisorCharge)),
	closeModal: () => dispatch(PAYMENTACTIONS.showPricingModal(false)),
	updateSetting: (field, newValue) => dispatch(COMPANYACTIONS.updateSetting(field, newValue)),
	showStripeDeleteModal: (id) => dispatch(PAYMENTACTIONS.showStripeDeleteModal(true, id)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PaymentMethods) 
